module.exports = __webpack_public_path__ + "static/media/DOUBLE-BREASTED 2 BUTTONS.f529dc78.svg";